import Cookies from 'universal-cookie';
import config from '@src/config';

const { isTest, type } = config;

export const range = (start, end) => {
	const length = end - start + 1;
	return Array.from({ length }, (_, i) => start + i);
};

export const checkIsServer = () => typeof window === 'undefined';

export const getTrustedSchoolHostname = req => req?.headers?.['x-school-hostname'];

export const clearQueryString = (url = '') => url.split('?')[0];

export const getApiData = req => {
	if (!req) {
		if (!checkIsServer()) {
			console.warn('[getApiData] called without req on client — should only be called during SSR');
		}
	}
	const cookies = new Cookies(req?.headers?.cookie);
	const internalApiDomain = checkIsServer() ? 'http://course-api:8001' : `https://${window.location.host}/api`;
	let apiDomain = internalApiDomain;
	let host = req?.headers['x-school-hostname'] || req?.headers?.host;
	let ssrHeaders = {
		'x-school-hostname': host,
		Authorization: cookies.get('token') || '',
	};

	if (isTest) {
		// internalApiDomain = 'https://staging.teaches.cc/api';
		// internalApiDomain = 'https://teaches.cc/api';
		// apiDomain = internalApiDomain;
		// ssrHeaders = {
		//   'x-school-hostname': host,
		//   host,
		// };
		// Local backend mode：API_PROXY_TARGET（server-only env，browser 端必為 undefined）有設時，
		// SSR 直接打本機裸 course-api（blueprint 掛在 root，不加 /api）；browser 端照舊走同源 /api
		// dev proxy（pages/api/[...slug].js，由它注入 X-SCHOOL-HOSTNAME）。
		apiDomain = (checkIsServer() && process.env.API_PROXY_TARGET) ?
			process.env.API_PROXY_TARGET :
			`https://${process.env.NEXT_PUBLIC_HOSTNAME}/api`;
		host = process.env.NEXT_PUBLIC_HOSTNAME;
		ssrHeaders = {
			'x-school-hostname': host,
			Authorization: cookies.get('token') || '',
		};
	}

	// Setup Domain
	const domain = `https://${host}`;
	// build 靜態生成（getStaticProps 頁面，如 /hr，及 Next 自動產的 /404）時 ctx.req 是 mock 物件，
	// req.headers 沒有 user-agent → 不能直接 .match()
	const userAgent = req?.headers?.['user-agent'];
	const ssrIsMobile = !!(userAgent && userAgent.match(
		/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i,
	));

	return {
		apiDomain,
		ssrHeaders,
		domain,
		ssrIsMobile,
	};
};

export const getPageTimeoutData = ({ req, time }) => {
	if (isTest) {
		return;
	}

	const { url } = req;
	const host = req?.headers['x-school-hostname'] || req?.headers?.host;
	const errorMessage = {
		type,
		msg: 'pageTimeout',
		host,
		url,
		time,
	};

	console.log(errorMessage);

	return errorMessage;
};
